export const demoFraudData: any = {
  records: [
    {
      person: {
        firstName: "Demo",
        lastName: "User",
      },
      reason: [
        {
          category: "IP",
          riskLevel: "low",
          possibleRiskFactors: [
            "IP address originates from an OFAC sanctioned country",
            "IP address is associated with spam activity",
            "IP address origin & usage indicates non-human traffic",
            "Proxy is from services that change location to beat DRM, TOR points, temporary proxies and other masking services",
            "IP proxy is TOR-based",
          ],
        },
        {
          category: "IpVelocity",
          riskLevel: "medium",
          possibleRiskFactors: [
            "More than 2 events associated with the IP address in the last 24 hours",
            "More than 4 events associated with the IP address in the last week",
            "More than 9 events associated with the IP address in the last 15 days",
            "More than 14 events associated with the IP address in the last 90 days",
          ],
        },
        {
          category: "Device",
          riskLevel: "high",
          possibleRiskFactors: [
            "Session connected using a proxy",
            "The Device Risk module was called, but a device token was not provided",
          ],
        },
        {
          category: "Email",
          riskLevel: "low",
          possibleRiskFactors: [
            "Email address risk is equal to or greater than 97%",
            "The email address is invalid - it does not meet standards, or the address does not exist at that server",
            "Email address is disposable",
            "Email address is auto-generated",
            "Email address is less than 180 days old",
            "Email address domain is less than 180 days old",
            "Email address domain is invalid",
            "Email address domain represents high risk",
            "Email address is associated with fraud",
            "Majority of characters in username are numbers",
          ],
        },
        {
          category: "Phone",
          riskLevel: "low",
          possibleRiskFactors: [
            "Phone number is invalid",
            "Phone number has not been actively used for more than 90 days",
            "Phone number is not allowed for consumers",
            "Phone number is prepaid",
            "Phone number risk is equal to or greater than 97%",
            "Phone number has ported within the past 24 hours",
            "Phone number has had a name change in the last 3 days",
            "A security freeze was initiated on a credit file containing this phone number and has not yet been lifted",
          ],
        },
        {
          category: "PhoneVelocity",
          riskLevel: "medium",
          possibleRiskFactors: [
            "More than 4 events associated with the phone in the last 15 days",
          ],
        },
        {
          category: "Address",
          riskLevel: "high",
          possibleRiskFactors: [
            "Address is invalid or does not exist",
            "Address cannot be resolved to the individual",
          ],
        },
        {
          category: "Identity",
          riskLevel: "low",
          possibleRiskFactors: [
            "SSN/ITIN cannot be resolved to the individual",
            "SSN has been reported as deceased",
            "Identity has been reported as deceased",
            "SSN issued prior to DOB",
            "SSN/ITIN is invalid",
            "Address is invalid or does not exist",
            "SSN/ITIN not found in public records",
            "SSN/ITIN is correlated with at least 1 other name and address",
            "SSN/ITIN is correlated to multiple identities",
            "Identity decease verified by SSA",
            "SSN/ITIN is associated with fraud",
          ],
        },
        {
          category: "IdentityVelocity",
          riskLevel: "medium",
          possibleRiskFactors: [
            "More than 5 events associated with the SSN in the last 24 hours",
            "More than 15 events associated with the SSN in the last week",
          ],
        },
        {
          category: "Ofac",
          riskLevel: "low",
          possibleRiskFactors: [
            "Watchlist search did not return at least one hit on OFAC SDN list",
          ],
        },
        {
          category: "NonOfacSanctions",
          riskLevel: "low",
          possibleRiskFactors: [
            "Watchlist did not return risks from standard databases.",
          ],
        },
        {
          category: "Pep",
          riskLevel: "low",
          possibleRiskFactors: [
            "Watchlist search did not return at least one hit as a politically exposed person",
          ],
        },
      ],
    },
  ],
};
